<template>
    <div>
        <SelecionarProduto v-model="pedido" v-if="m_tela === SELECIONAR_PRODUTO" @input="$listeners.input" @nextPage="irParaSelecionarBem()" @prevPage="voltar()" />
        <SelecionarBem ref="selecionarBemRef" v-model="pedido" v-if="m_tela === SELECIONAR_BEM" @input="$listeners.input" @nextPage="irParaSelecionarPrazo" @prevPage="irParaSelecionarProduto()" :filtro-catalogo="filtroCatalogo" @filtroCatalogo="$listeners.filtroCatalogo" @showModalBroker="(val) => $emit('showModalBroker', val)"/>
        <SelecionarPrazo v-model="pedido" v-if="m_tela === SELECIONAR_PRAZO" @input="$listeners.input" @nextPage="$listeners.nextPage" @prevPage="irParaSelecionarBem()" />
    </div>
</template>

<script>
  import SelecionarProduto from './SelecionarProduto'
  import SelecionarBem from './SelecionarBem'
  import SelecionarPrazo from '@/views/cadastro/produto/SelecionarPrazo'

  export default {
    name: 'Produto',
    components: { SelecionarPrazo, SelecionarBem, SelecionarProduto },
    props: { value: Object, tela: { type: String, validators: [ 'produto', 'bem' ] }, filtroCatalogo: Object },
    data: () => ({
      pedido: {},
      m_tela: '',
      onAtualizarCatalogo: false
    }),
    computed: {
      SELECIONAR_PRODUTO: () => 'produto',
      SELECIONAR_BEM: () => 'bem',
      SELECIONAR_PRAZO: () => 'prazo'
    },
    watch: {
      value (val) {
        this.pedido = Object.assign({}, this.pedido, val)
      },
      tela (val) {
        this.m_tela = val
      }
    },
    mounted () {
      this.pedido = Object.assign({}, this.pedido, this.value)
      this.m_tela = this.tela || this.SELECIONAR_PRODUTO
    },
    methods: {
      irParaSelecionarProduto () {
        this.m_tela = this.SELECIONAR_PRODUTO
        this.$emit('telaProduto', this.SELECIONAR_PRODUTO)
      },
      irParaSelecionarBem () {
        this.m_tela = this.SELECIONAR_BEM
        this.$emit('telaProduto', this.SELECIONAR_BEM)
      },
      irParaSelecionarPrazo () {
        this.m_tela = this.SELECIONAR_PRAZO
        this.$emit('telaProduto', this.SELECIONAR_PRAZO)
      },
      voltar () {
        this.$emit('telaProduto', this.SELECIONAR_PRODUTO)
        this.$emit('prevPage')
      },
      onPreparacaoFinished () {
        // Só chama se SelecionarBem está ativo e tem o método
        if (this.$refs.selecionarBemRef && this.$refs.selecionarBemRef.onPreparacaoFinished) {
          this.$refs.selecionarBemRef.onPreparacaoFinished()
        } else {
          // Senão, marca flag para atualizar depois
          this.onAtualizarCatalogo = true
        }
      }
    }
  }
</script>
